import React from "react";
import { TouchableDiv, TouchableButton } from "@components/common/Touchable";
import { ReactComponent as ResetIcon } from "@assets/images/reset.svg";
import CashCalculator from "./CashCalculatorNewUI";
import styles from "./index.module.scss";
import uniqBy from "lodash/uniqBy";
import cn from "classnames";
import PropTypes from "prop-types";

const CashViewVertical = (props) => {
  const {
    serverAppTheme,
    LABEL,
    currenySymbol,
    creditCardAmount,
    showCheckSeat,
    handleResetClick,
    isCounter,
    Amount,
    handleBlur,
    cashCalculatorRef,
    handleChangeValue,
    setIsCounterCash,
    setshowCalculator,
    showCalculator,
    setAmount,
    preDefinedvalue,
    cashMode,
    setCreditCardAmount,
    childStateUpdate,
    isDriveThru,
    possibleCashOptions,
    setpreDefinedvalue,
    setChangeAmount,
    getCashReturnList,
    setGroupedList,
    setCashPaymentValue,
    paymentType,
    isCashMode,
    changeAmount,
    filteredList,
    groupedList,
    handleRouteCross,
    isAmountForPayValid,
    handleCheck,
    cashDataToSend,
    isLandScapeMode,
    setErrorPopUp,
    seat,

  } = props;

  return (
    <>
      {/* 1 */}
      {!!(seat?.paymentCheck?.cash?.roundingAmount ?? 0) && (
        <div className="d-flex pb-3">
          <div className="col-6 h-6 px-2 d-flex align-items-center rounded">
            <div className="fs_20 fw-600">
              {LABEL().TOTAL} {seat?.paymentCheck?.totalDueAmount}
            </div>
          </div>
          <div className="col-6 h-6 px-0 pr-2 d-flex align-items-center rounded">
            <div className="fs_20 fw-600 w-100 text-right">
              {LABEL().EPS_ROUNDING} {seat?.paymentCheck?.cash?.roundingAmount}
            </div>
          </div>
        </div>
      )}
      <div
        className="col-12 h-6 px-3 d-flex align-items-center rounded"
        style={{ backgroundColor: serverAppTheme?.input_box_background }}
      >
        <div className="col-6 px-0 text-left fs_20 fw-600">
          {LABEL().EPS_DUE}
        </div>
        <div className="col-6 px-0 text-right fs_28 fw-500">
          {currenySymbol}
          {String(Number(creditCardAmount)?.toFixed(2))}
        </div>
      </div>
      {/* 2 */}
      <div
        className={cn("col-12 row mx-0 px-0", showCheckSeat() && "h-55")}
        style={{ height: !showCheckSeat() && "51%" }}
      >
        <div
          className={cn("col-12 row mx-0 px-0", !showCheckSeat() && "h-20")}
          style={{ height: showCheckSeat() && "27%" }}
        >
          <div className="h-90 row mx-0 pt-3">
            <div className="col-7 px-0 fs_24 fw-600 h-100 d-flex align-items-center">
              {LABEL().EPS_AMOUNT_COLLECTED}
            </div>
            <TouchableDiv
              className="col-1 px-0 d-flex justify-content-center align-items-center"
              tabIndex="0"
              role="button"
              onClick={(e) => {
                e.preventDefault();
                handleResetClick();
              }}
            >
              <ResetIcon fill={serverAppTheme?.iconcolor} />
            </TouchableDiv>
            <div className={cn("col-4 p-0 row mx-0")}>
              <div
                className={cn(
                  "px-0 h-100 position-relative d-flex align-items-center justify-content-end",
                )}
              >
                <input
                  id={name}
                  type="text"
                  className={cn(
                    "h-89 p-2 pl-3 fs_28 fw-500 text-left",
                    styles.inputFild,
                  )}
                  style={{
                    width: "92%",
                    height: "64px",
                    background: serverAppTheme?.inputBg,
                    borderBottom: serverAppTheme?.inputBorder_Bottom,
                    color: serverAppTheme?.primary_text,
                  }}
                  value={`${currenySymbol}${String(
                    Number(Amount)?.toFixed(2),
                  )}`}
                  onFocus={() => {
                    handleBlur();
                  }}
                  readOnly
                />
              </div>
            </div>
          </div>
        </div>

        <div className="w-100 h-70 row mx-0 px-0">
          <div className={cn("pr-2 pl-0 h-100")} style={{ width: "68%" }}>
            <div className={cn("w-100 h-auto")}>
              <CashCalculator
                ref={cashCalculatorRef}
                name="cashCalculator"
                onChange={handleChangeValue}
                onClickIcon={() => setIsCounterCash(true)}
                value={String(Amount)}
                currenySymbol={currenySymbol}
                setshowCalculator={setshowCalculator}
                showCalculator={showCalculator}
                isCounter={isCounter}
                serverAppTheme={serverAppTheme}
                setAmount={setAmount}
                preDefinedvalue={preDefinedvalue}
                cashMode={cashMode}
                handleStateClear={() => setCreditCardAmount("0")}
                callbackToUpdateInputs={(callbackFun) =>
                  (childStateUpdate.current = callbackFun)
                }
                isDriveThru={isDriveThru}
                isLandScapeMode={isLandScapeMode}
              />
            </div>
          </div>
          <div className="px-0 h-100 overflowY" style={{ width: "31.5%" }}>
            <div
              className={cn(
                "row px-0 w-100 mx-0 fw-600 fs-24 h-auto",
              )}
            >
              {possibleCashOptions?.length > 0 &&
                uniqBy(possibleCashOptions, "key")?.map(
                  ({ label, key }, index) => {
                    return (
                      <TouchableDiv
                        role="presentation"
                        onClick={() => {
                          setpreDefinedvalue(false);
                          setAmount(key);
                          let changeAmt = +(key - creditCardAmount)?.toFixed(2);
                          setChangeAmount(changeAmt > 0 ? changeAmt : 0.0);
                          const result = getCashReturnList(changeAmt);
                          setGroupedList(result);
                          setCashPaymentValue(label);
                        }}
                        className={cn(
                          "text-center w-100",
                          index ===
                            uniqBy(possibleCashOptions, "key").length - 1
                            ? "pl-1"
                            : "pl-1 pb-2",
                        )}
                      >
                        <TouchableButton
                          className={cn(
                            "col-12  d-flex justify-content-center align-items-center btn-ripple fs_22 border-0 roundedLg od-secondary-btn-bg-color od-secondary-btn-font-color p-0",
                            styles.btnPrimary,
                            styles.btnPrimaryCash,
                          )}
                          style={{
                            fontWeight: "600",
                            fontFamily: "Poppins",
                            background: serverAppTheme?.primaryBtn,
                          }}
                          rippleEffect={true}
                        >
                          {label}
                        </TouchableButton>
                      </TouchableDiv>
                    );
                  },
                )}
            </div>
          </div>
        </div>
      </div>
      {/* 3 */}
      <div
        className={cn("col-12 px-0 d-flex align-items-end")}
        style={{
          backgroundColor: serverAppTheme?.input_box_background,
          height: showCheckSeat()
            ? (seat?.paymentCheck?.cash?.roundingAmount ? '24%' : '28%') : (seat?.paymentCheck?.cash?.roundingAmount ? '28%' : '31%')
          }}
      >
        <div className="col-12 px-12 rounded">
          <div
            className={cn(
              [16].includes(paymentType) && !isCashMode ? "h-50 d-flex" : "",
              "w-100 flex-wrap overflowY",
            )}
            style={{
              height: Number(changeAmount) > 0 && isCashMode && "auto",
              maxHeight: Number(changeAmount) > 0 && isCashMode && "220px",
            }}
          >
            {filteredList(groupedList)?.map(
              (
                {
                  length,
                  value,
                  unitSymbol,
                  isHigherUnit,
                  computedValueInHigherUnit,
                },
                index,
              ) => {
                const displayAmt = value;
                const concatAmtWithSymbol = isHigherUnit
                  ? `${unitSymbol}${displayAmt}`
                  : `${displayAmt}${unitSymbol}`;
                return (
                  <div
                    className={`w-100 row mx-0 fs_20 fw-400 ${
                      index === 0 && "pt-2"
                    }`}
                  >
                    <div className="w-50 text-left">{`${length} x ${concatAmtWithSymbol}`}</div>
                    <div className="w-50 text-right">{`${computedValueInHigherUnit}`}</div>
                  </div>
                );
              },
            )}
          </div>
          <div
            className="col-12 px-0 fs_24 fw-600 d-flex pt-1"
            style={{ bottom: 0 }}
          >
            <div className="col-6 px-0 text-left">{LABEL().EPS_CHANGE}</div>
            <div className="col-6 px-0 text-right">
              {currenySymbol}
              {Number(changeAmount).toFixed(2)}
            </div>
          </div>
        </div>
      </div>
      {/* 4 */}
      {showCalculator && (
        <div
          className="col-12 px-0 w-100 h-10 position-absolute d-flex justify-content-center align-items-end"
          style={{ bottom: 0 }}
        >
          <div className="col-6 pl-0 pr-1">
            <TouchableButton
              type="button"
              className="w-100 rounded btn-ripple fs_28 fw-600 od-cancel-btn-bg-color  od-cancel-btn-font-color od-cancel-btn-st-color"
              style={{
                height: "7.5vh",
                color: serverAppTheme?.cancleBtn_font,
                backgroundColor: serverAppTheme?.OFF_Premise_Btn,
                border: serverAppTheme?.cancleBtn_Border,
              }}
              onClick={(e) => {
                e.preventDefault();
                handleRouteCross();
              }}
              rippleEffect={true}
            >
              {LABEL().EPS_CANCEL}
            </TouchableButton>
          </div>
          <div className="col-6 pl-1 pr-0">
            <TouchableButton
              type="button"
              onClick={(e) => {
                e.preventDefault();
                if (isAmountForPayValid) {
                  setErrorPopUp({
                    res: `Amount should be greater than or equal to ${currenySymbol} ${creditCardAmount}`,
                    noErrorTxt: true,
                  });
                  return;
                }
                handleCheck("counterCashPay", cashDataToSend);
              }}
              className={cn(
                "w-100 rounded btn-ripple fs_28 od-primary-btn-bg-color od-primary-btn-font-color btn70",
                styles.btnSecondary,
              )}
              style={{ height: "7.5vh" }}
              rippleEffect={true}
            >
              {LABEL().EPS_APPLY}
            </TouchableButton>
          </div>
        </div>
      )}
    </>
  );
};

CashViewVertical.propTypes = {
  serverAppTheme: PropTypes.object,
  LABEL: PropTypes.func,
  currenySymbol: PropTypes.string,
  creditCardAmount: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  showCheckSeat: PropTypes.func,
  handleResetClick: PropTypes.func,
  isCounter: PropTypes.bool,
  Amount: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  handleBlur: PropTypes.func,
  cashCalculatorRef: PropTypes.object,
  handleChangeValue: PropTypes.func,
  setIsCounterCash: PropTypes.func,
  setshowCalculator: PropTypes.func,
  showCalculator: PropTypes.bool,
  setAmount: PropTypes.func,
  preDefinedvalue: PropTypes.bool,
  cashMode: PropTypes.bool,
  setCreditCardAmount: PropTypes.func,
  childStateUpdate: PropTypes.object,
  isDriveThru: PropTypes.bool,
  possibleCashOptions: PropTypes.array,
  setpreDefinedvalue: PropTypes.func,
  setChangeAmount: PropTypes.func,
  getCashReturnList: PropTypes.func,
  setGroupedList: PropTypes.func,
  setCashPaymentValue: PropTypes.func,
  paymentType: PropTypes.number,
  isCashMode: PropTypes.bool,
  changeAmount: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  filteredList: PropTypes.func,
  groupedList: PropTypes.array,
  handleRouteCross: PropTypes.func,
  isAmountForPayValid: PropTypes.bool,
  handleCheck: PropTypes.func,
  cashDataToSend: PropTypes.object,
  isLandScapeMode: PropTypes.bool,
  setErrorPopUp: PropTypes.func,
};

CashViewVertical.defaultProps = {
  serverAppTheme: {},
  LABEL: () => ({}),
  currenySymbol: "",
  creditCardAmount: 0,
  showCheckSeat: () => false,
  handleResetClick: () => {},
  isCounter: false,
  Amount: 0,
  handleBlur: () => {},
  cashCalculatorRef: null,
  handleChangeValue: () => {},
  setIsCounterCash: () => {},
  setshowCalculator: () => {},
  showCalculator: false,
  setAmount: () => {},
  preDefinedvalue: false,
  cashMode: false,
  setCreditCardAmount: () => {},
  childStateUpdate: { current: null },
  isDriveThru: false,
  possibleCashOptions: [],
  setpreDefinedvalue: () => {},
  setChangeAmount: () => {},
  getCashReturnList: () => [],
  setGroupedList: () => {},
  setCashPaymentValue: () => {},
  paymentType: 0,
  isCashMode: false,
  changeAmount: 0,
  filteredList: () => [],
  groupedList: [],
  handleRouteCross: () => {},
  isAmountForPayValid: false,
  handleCheck: () => {},
  cashDataToSend: {},
  isLandScapeMode: false,
  setErrorPopUp: () => {},
};


export default CashViewVertical;
